import React, { useRef, useState } from 'react';
import ReactAudio from 'react-h5-audio-player';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentBookPath } from '../../../asset/utils/Constant';
import { setSlide, setWordPlay } from '../../../store/CardSlice';
import { Item } from '../../_atoms/Item';
import { List } from '../../_atoms/List';
import { Span } from '../../_atoms/Span';

const AudioPlayer = styled(ReactAudio)`
  width : 0;
  height : 0;
  opacity: 0;
  display: none;
`;

export const CardList = (props) => {  
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const [mp3, setMp3] = useState('');

  const player = useRef();

  const onCardClick = (idx, i) => {
    if (state.card.word_play) {
      return false;
    }

    const slideArray = state.card.slide[idx].map((slide, num) => {
      if (i === num) {
        return {
          ...slide,
          act : true,
          choice : true  
        }
      } else {
        return {
          ...slide,
          act : true,
          choice : false  
        }
      }
    });

    dispatch(setSlide([
      ...state.card.slide.slice(0, idx),
      slideArray,
      ...state.card.slide.slice(idx + 1)
    ]));

    setMp3(ContentBookPath + (state.book.current_book + 1) + '/flashCard/mp3/' + state.card.slide[idx][i].word + '.mp3');
    dispatch(setWordPlay(true));
  };

  const onWordPlayEnd = (idx) => {
    setMp3('');
    dispatch(setWordPlay(false));

    const slideArray = state.card.slide[idx].map((slide) => {
      if (slide.act === true && slide.choice === true) {
        return {
          ...slide,
          act : false,
          reset : true,
          back : !slide.back
        }
      } else {
        return {
          ...slide,
          act : false,
          reset : true
        }
      }
    });

    dispatch(setSlide([
      ...state.card.slide.slice(0, idx),
      slideArray,
      ...state.card.slide.slice(idx + 1)
    ]));
  };

  return (
    <>
      <List order={false} type="card">
        {props.card.map((word, i) => {
          return (
            <Item 
              type="card"
            >
              <Span
                type="card" 
                src={word.src} 
                wsrc={word.wsrc}
                act={word.act}
                choice={word.choice}
                back={word.back}
                reset={word.reset}
                className={state.card.slide[props.idx][i].act ? (state.card.slide[props.idx][i].choice ? 'ani1 ani2' : 'ani3 ani4') : (state.card.slide[props.idx][i].choice ? 'ani1' : 'ani3')}
                onClick={() => onCardClick(props.idx, i)}
              />
            </Item>
          )
        })}
      </List>
      <AudioPlayer
        ref={player}
        src={mp3}
        autoPlayAfterSrcChange={state.card.word_play}
        showSkipControls={true}
        showJumpControls={false}
        hasDefaultKeyBindings={false}
        preload="true"
        onEnded={() => onWordPlayEnd(props.idx)}
      />
    </>
  );
};